import React from 'react';
import Buttons from '../element/buttons';
import Configuration from '../../utils/configuration';
import APIManager from '../../utils/APIManager';

export function imgText(props) {
	let bg_image = {
		backgroundImage: `url(${Configuration.RESOURCES_URL}static/significa.jpg)`
	};
	return (
		<div className="imgText">
			<div className="imgText-image" style={bg_image}>
				{/* <img src={`${Configuration.RESOURCES_URL}static/significa.jpg`} /> */}
			</div>
			<div className="imgText-text">
				<div className="imgText-content" dangerouslySetInnerHTML={{ __html: props.part['content'] }} />
				<div className="imgText-button">
					<Buttons part_buttons={props.part_buttons} />
				</div>
			</div>
		</div>
	);
}

export function formInscripcion(props) {
	const postForm = (event) => {
		event.preventDefault();
		APIManager.post('subscribers/subscribe', event.target.elements);
	};
	return (
		<div className="flex">
			<div className="content flex">
				<form className="form" method="post" onSubmit={postForm}>
					<div className="form__left">
						<div className="form__title">
							<h3>
								INSCRIPCIÓN<br /> A LA GALA EMBAJADORES
							</h3>
						</div>
						<div className="form_subtitle">
							<h3>2019</h3>
						</div>
					</div>
					<div className="form__container">
						<p>
							El plazo de inscripción online está cerrado. Póngase en contacto con el Club de Empresas de
							Turismo de Negocios de Asturias llamando al <a href="tel:985180153">(985) 180-153</a> o bien
							por mail <a href="mailto:info@asturiascongresos.com">info@asturiascongresos.com</a>
						</p>
					</div>
				</form>
			</div>
		</div>
	);
}
